import type { Account } from "@/query/graphql"

export type SecurityCouncilAccount = Pick<Account, "address"> & {
  type: "EOA" | "SAFE"
  name?: string
  networkShortname?: string
}
export type SecCouncilMembersSettings = {
  accounts: SecurityCouncilAccount[]
  learnMoreUrl?: string
}

// Hardcoded list of Organizations with Members settings
const SEC_COUNCIL_MEMBERS_ORG_SETTINGS: Record<
  string,
  Record<string, SecCouncilMembersSettings>
> = {
  "https://api.tally.xyz": {
    // zkSync: https://www.tally.xyz/gov/zksync
    "2297436623035434412": {
      accounts: [
        {
          networkShortname: "eth",
          address: "0x84BF0Ac41Eeb74373Ddddae8b7055Bf2bD3CE6E0",
          name: "Chainlight",
          type: "SAFE",
        },
        {
          networkShortname: "eth",
          address: "0x35eA56fd9eAd2567F339Eb9564B6940b9DD5653F",
          name: "Cyfrin",
          type: "SAFE",
        },
        {
          networkShortname: "eth",
          address: "0xB7aC3A79A23B148c85fba259712c5A1e7ad0ca44",
          name: "Dedaub",
          type: "SAFE",
        },
        {
          networkShortname: "eth",
          address: "0x725065b4eB99294BaaE57AdDA9c32e42F453FA8A",
          name: "Mariano Conti",
          type: "SAFE",
        },
        {
          networkShortname: "eth",
          address: "0xc3Abc9f9AA75Be8341E831482cdA0125a7B1A23e",
          name: "Matter Labs",
          type: "SAFE",
        },
        {
          networkShortname: "eth",
          address: "0x69462a81ba94D64c404575f1899a464F123497A2",
          name: "Nethermind",
          type: "SAFE",
        },
        {
          networkShortname: "eth",
          address: "0x34Ea62D4b9bBB8AD927eFB6ab31E3Ab3474aC93a",
          name: "Open Zeppelin",
          type: "SAFE",
        },
        {
          networkShortname: "eth",
          address: "0xFB90Da9DC45378A1B50775Beb03aD10C7E8DC231",
          name: "Peckshield",
          type: "SAFE",
        },
        {
          networkShortname: "eth",
          address: "0x9B8Be3278B7F0168D82059eb6BAc5991DcdfA803",
          name: "Spearbit",
          type: "SAFE",
        },
        {
          networkShortname: "eth",
          address: "0x9B39Ea22e838B316Ea7D74e7C4B07d91D51ccA88",
          name: "Violet",
          type: "SAFE",
        },
        {
          networkShortname: "eth",
          address: "0x13f07d9BF17615f6a17F272fe1A913168C275A66",
          name: "Yev Broshevan",
          type: "SAFE",
        },
        {
          networkShortname: "eth",
          address: "0x3888777686F0b0d8c3108fc22ad8DE9E049bE26F",
          name: "Yoav Weiss",
          type: "SAFE",
        },
      ],
      learnMoreUrl:
        "https://docs.zknation.io/zksync-governance/schedule-3-zksync-security-council",
    },
    // testnet-zksync: https://www.tally.xyz/gov/testnet-zksync
    "2383575338992010920": {
      accounts: [
        {
          networkShortname: "eth",
          address: "0x84BF0Ac41Eeb74373Ddddae8b7055Bf2bD3CE6E0",
          name: "Chainlight",
          type: "SAFE",
        },
        {
          networkShortname: "eth",
          address: "0x35eA56fd9eAd2567F339Eb9564B6940b9DD5653F",
          name: "Cyfrin",
          type: "SAFE",
        },
        {
          networkShortname: "eth",
          address: "0xB7aC3A79A23B148c85fba259712c5A1e7ad0ca44",
          name: "Dedaub",
          type: "SAFE",
        },
        {
          networkShortname: "eth",
          address: "0x725065b4eB99294BaaE57AdDA9c32e42F453FA8A",
          name: "Mariano Conti",
          type: "SAFE",
        },
        {
          networkShortname: "eth",
          address: "0xc3Abc9f9AA75Be8341E831482cdA0125a7B1A23e",
          name: "Matter Labs",
          type: "SAFE",
        },
        {
          networkShortname: "eth",
          address: "0x69462a81ba94D64c404575f1899a464F123497A2",
          name: "Nethermind",
          type: "SAFE",
        },
        {
          networkShortname: "eth",
          address: "0x34Ea62D4b9bBB8AD927eFB6ab31E3Ab3474aC93a",
          name: "Open Zeppelin",
          type: "SAFE",
        },
        {
          networkShortname: "eth",
          address: "0xFB90Da9DC45378A1B50775Beb03aD10C7E8DC231",
          name: "Peckshield",
          type: "SAFE",
        },
        {
          networkShortname: "eth",
          address: "0x9B8Be3278B7F0168D82059eb6BAc5991DcdfA803",
          name: "Spearbit",
          type: "SAFE",
        },
        {
          networkShortname: "eth",
          address: "0x9B39Ea22e838B316Ea7D74e7C4B07d91D51ccA88",
          name: "Violet",
          type: "SAFE",
        },
        {
          networkShortname: "eth",
          address: "0x13f07d9BF17615f6a17F272fe1A913168C275A66",
          name: "Yev Broshevan",
          type: "SAFE",
        },
        {
          networkShortname: "eth",
          address: "0x3888777686F0b0d8c3108fc22ad8DE9E049bE26F",
          name: "Yoav Weiss",
          type: "SAFE",
        },
      ],
      learnMoreUrl:
        "https://docs.zknation.io/zksync-governance/schedule-3-zksync-security-council",
    },
    // testnet-codename: https://www.tally.xyz/gov/testnet-codename
    "2333649329245390000": {
      accounts: [
        {
          networkShortname: "eth",
          address: "0x84BF0Ac41Eeb74373Ddddae8b7055Bf2bD3CE6E0",
          name: "Chainlight",
          type: "SAFE",
        },
        {
          networkShortname: "eth",
          address: "0x35eA56fd9eAd2567F339Eb9564B6940b9DD5653F",
          name: "Cyfrin",
          type: "SAFE",
        },
        {
          networkShortname: "eth",
          address: "0xB7aC3A79A23B148c85fba259712c5A1e7ad0ca44",
          name: "Dedaub",
          type: "SAFE",
        },
        {
          networkShortname: "eth",
          address: "0x725065b4eB99294BaaE57AdDA9c32e42F453FA8A",
          name: "Mariano Conti",
          type: "SAFE",
        },
        {
          networkShortname: "eth",
          address: "0xc3Abc9f9AA75Be8341E831482cdA0125a7B1A23e",
          name: "Matter Labs",
          type: "SAFE",
        },
        {
          networkShortname: "eth",
          address: "0x69462a81ba94D64c404575f1899a464F123497A2",
          name: "Nethermind",
          type: "SAFE",
        },
        {
          networkShortname: "eth",
          address: "0x34Ea62D4b9bBB8AD927eFB6ab31E3Ab3474aC93a",
          name: "Open Zeppelin",
          type: "SAFE",
        },
        {
          networkShortname: "eth",
          address: "0xFB90Da9DC45378A1B50775Beb03aD10C7E8DC231",
          name: "Peckshield",
          type: "SAFE",
        },
        {
          networkShortname: "eth",
          address: "0x9B8Be3278B7F0168D82059eb6BAc5991DcdfA803",
          name: "Spearbit",
          type: "SAFE",
        },
        {
          networkShortname: "eth",
          address: "0x9B39Ea22e838B316Ea7D74e7C4B07d91D51ccA88",
          name: "Violet",
          type: "SAFE",
        },
        {
          networkShortname: "eth",
          address: "0x13f07d9BF17615f6a17F272fe1A913168C275A66",
          name: "Yev Broshevan",
          type: "SAFE",
        },
        {
          networkShortname: "eth",
          address: "0x3888777686F0b0d8c3108fc22ad8DE9E049bE26F",
          name: "Yoav Weiss",
          type: "SAFE",
        },
      ],
      learnMoreUrl:
        "https://docs.zknation.io/zksync-governance/schedule-3-zksync-security-council",
    },

    // agld: https://www.tally.xyz/gov/agld
    // "2398908670663460078": {
    //   accounts: [
    //     {
    //       address: "0xE9DF211818017889643Fc606937766B6fe2cDBA4",
    //       type: "EOA",
    //     },
    //     {
    //       address: "0x5e47efFcBe57D1Fc553ff61B4e33E0606b880de5",
    //       type: "EOA",
    //     },
    //     {
    //       address: "0xC492ec3a55953011C95d077573c583193529FeC4",
    //       type: "EOA",
    //     },
    //     {
    //       type: "EOA",
    //       address: "0x2dB6B8F5A2Dc681A20B122215e1B5fCDCF65B492",
    //     },
    //     {
    //       address: "0x49180Df56d9FEb4f6C1f51D3f85Eb111B4C2980E",
    //       type: "EOA",
    //     },
    //   ],
    // },
  },

  "https://api.staging.tally.xyz": {},
}

export const getSecCouncilMembersOrganizationSettings = (
  organizationId: string,
) => {
  return SEC_COUNCIL_MEMBERS_ORG_SETTINGS?.[
    process.env.NEXT_PUBLIC_TALLY_API_URL
  ]?.[organizationId]
}
